import Icon from '../components/Icon.vue'

Icon.register({
  pen: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M290.7 93.2l128 128-278 278-114.1 12.6c-15.3 1.7-28.2-11.2-26.5-26.5l12.7-114.2zM497.9 74.2c18.8 18.8 18.8 49.2 0 67.9l-56.6 56.5-128-128 56.5-56.5c18.8-18.8 49.2-18.8 67.9 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pen.js
// module id = 1622
// module chunks = 0